import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { LogOut, Eye } from 'lucide-react';
import api from '@/utils/api';
import { useNavigate } from 'react-router-dom';

export const ImpersonationBanner = () => {
  const [isImpersonation, setIsImpersonation] = useState(false);
  const [adminName, setAdminName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    checkImpersonationStatus();
  }, []);

  const checkImpersonationStatus = async () => {
    const impersonationFlag = localStorage.getItem('is_impersonation');
    if (impersonationFlag === 'true') {
      try {
        const response = await api.get('/auth/impersonation-status');
        if (response.data.is_impersonation) {
          setIsImpersonation(true);
          setAdminName(response.data.admin_name || 'Admin');
        }
      } catch (error) {
        console.error('Failed to check impersonation status:', error);
      }
    }
  };

  const handleEndImpersonation = async () => {
    try {
      // Restore admin token
      const adminToken = localStorage.getItem('admin_token');
      if (adminToken) {
        localStorage.setItem('token', adminToken);
        localStorage.removeItem('admin_token');
        localStorage.removeItem('is_impersonation');
        
        // Get admin user info
        const response = await api.get('/auth/me');
        localStorage.setItem('user', JSON.stringify(response.data));
        
        navigate('/admin');
        window.location.reload();
      }
    } catch (error) {
      console.error('Failed to end impersonation:', error);
    }
  };

  if (!isImpersonation) return null;

  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div 
      className="fixed top-0 left-0 right-0 z-50 py-2 px-4 flex items-center justify-center gap-4"
      style={{ backgroundColor: '#FFF8E7', borderBottom: '2px solid #E2A761' }}
    >
      <Eye className="h-4 w-4" style={{ color: '#E2A761' }} />
      <span style={{ color: '#163329' }}>
        <strong>{adminName}</strong> is viewing as <strong>{currentUser.name}</strong> ({currentUser.role})
      </span>
      <Button
        size="sm"
        onClick={handleEndImpersonation}
        className="ml-2"
        style={{ backgroundColor: '#163329', color: '#FAF9F6' }}
      >
        <LogOut className="h-4 w-4 mr-1" />
        Exit Impersonation
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
